var module = angular.module('octopusApp.infrastructure');

module.controller('MessageBoxController', function ($scope, busy, options, $uibModalInstance) {
  var isWorking = $scope.isWorking = busy.create();
  $scope.options = options;

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.submit = function (result) {
    $uibModalInstance.close(result);
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/controllers/message_box_controller.js
// module id = 648
// module chunks = 1